import HelpIcon from '@/components/icons/navigations/HelpIcon.vue'
import ReferralIcon from '@/components/icons/navigations/ReferralIcon.vue'
import WithdrawalIcon from '@/components/icons/navigations/WithdrawalIcon.vue'
import ReportingIcon from '@/components/icons/navigations/ReportingIcon.vue'
import RatesIcon from '@/components/icons/navigations/RatesIcon.vue'

import { ROUTES } from '@/constants/routes'
import { NAVIGATION_ACTIONS } from '@/constants/navigationActions'

const reporting = {
    id: 1,
    name: 'Reporting',
    routeName: ROUTES.reporting,
    icon: () => ReportingIcon,
}

const referrals = {
    id: 2,
    name: 'Referrals',
    routeName: ROUTES.referral,
    icon: () => ReferralIcon,
}

const withdrawal = {
    id: 3,
    name: 'Withdrawal',
    routeName: ROUTES.withdrawal,
    icon: () => WithdrawalIcon,
}

const rates = {
    id: 4,
    name: 'Rates',
    routeName: ROUTES.rates,
    icon: () => RatesIcon,
}

const MENU_ROUTES_AFFILIATE = [reporting, referrals, withdrawal]
const MENU_ROUTES_RESELLER = [reporting, referrals, withdrawal, rates]

const BOTTOM_MENU_ROUTES = [
    {
        id: 4,
        name: 'Help',
        action: NAVIGATION_ACTIONS.help,
        icon: () => HelpIcon,
    },
]

export {
    MENU_ROUTES_AFFILIATE,
    MENU_ROUTES_RESELLER,
    BOTTOM_MENU_ROUTES,
}
